"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function CtaThreeSection({ heading = "Digital agencies and consultants also commonly qualify" }: { heading?: string } = {}) {
  return (
    <section className="w-full flex justify-center py-[30px] md:py-[60px] px-4 min-[1340px]:px-0">
      
      <div className="w-full max-w-[1200px] flex flex-col lg:flex-row items-center gap-8 lg:gap-[32px]">
        
        {/* IMAGE */}
        <div className="w-full lg:flex-1">
          <Image
            src="/tax-optimization/cta-three.webp"
            alt="Agency CTA"
            width={800}
            height={600}
            className="w-full h-[240px] sm:h-[320px] lg:h-[400px] object-cover rounded-[16px]"
          />
        </div>

        {/* TEXT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium">
              If your clients are overseas and services are delivered remotely,
              profits may qualify as offshore. This applies to marketing agencies,
              design studios, development teams, automation consultants, and
              strategy advisors.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}